export const parsePx = (value: string, fallback: number) => {
  const n = Number.parseFloat(String(value).replace('px', ''));
  return Number.isFinite(n) ? n : fallback;
};
